import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { trackPageview } from '@/lib/analytics';

/**
 * Fires `$pageview` on every route change. Mount once inside the router
 * (e.g. in App.tsx so it's child of <RouterProvider>). Pathnames don't
 * include query strings — keeps funnel grouping clean. The one exception
 * is the short `?src=` attribution param the backend stamps on Learn
 * deep-links in shipped/delivered SMS/email (`ss`/`se`/`ds`/`de` =
 * shipped/delivered × SMS/email); it's forwarded as a `src` event
 * property so we can see which notifications drive article visits.
 */
export function PageviewTracker() {
  const location = useLocation();
  useEffect(() => {
    // window.location (not the hook) so a same-path query change doesn't
    // fire a duplicate $pageview — cadence stays pathname-driven.
    const source = new URLSearchParams(window.location.search).get('src');
    const src = source && ['ss', 'se', 'ds', 'de'].includes(source) ? source : undefined;
    trackPageview(location.pathname, src ? { src } : undefined);
  }, [location.pathname]);
  return null;
}
